import React, { useId } from "react";

const VARIANTS = {
  primary: "bg-[var(--gz-blue)] text-white border-transparent hover:bg-[var(--gz-blue-hover)]",
  success: "bg-[var(--gz-green)] text-white border-transparent hover:bg-[var(--gz-green-hover)]",
  secondary: "bg-surface text-fg border-line hover:bg-hover",
  warning: "bg-warning-bg text-warning-fg border-warning-fg/40 hover:brightness-95",
  danger: "bg-danger-bg text-danger-fg border-danger-fg/50 hover:bg-[var(--gz-red)] hover:text-white",
};

/**
 * Button that explains itself when unavailable. A disabled <button> swallows pointer events and
 * focus, so the reason lives on a focusable wrapper (title + visually hidden description).
 */
export default function DisabledReasonButton({
  disabled, reason, variant = "secondary", title, className = "", children, ...rest
}) {
  const id = useId();
  const showReason = disabled && reason;
  const btn = (
    <button
      type="button"
      disabled={disabled}
      aria-disabled={disabled || undefined}
      aria-describedby={showReason ? id : undefined}
      title={disabled ? undefined : title}
      className={`inline-flex h-8 min-w-[2rem] items-center justify-center gap-1.5 whitespace-nowrap rounded border px-3 text-xs font-semibold transition-colors disabled:cursor-not-allowed disabled:border-line disabled:bg-surface-muted disabled:text-fg-disabled disabled:hover:bg-surface-muted ${VARIANTS[variant] || VARIANTS.secondary} ${className}`}
      {...rest}
    >
      {children}
    </button>
  );
  if (!showReason) return btn;
  return (
    <span tabIndex={0} title={reason} className="inline-flex rounded" data-disabled-reason={reason}>
      {btn}
      <span id={id} className="sr-only">{reason}</span>
    </span>
  );
}
